"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _services = require("../../services");
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var _default = function _default(config) {
  var contextConfiguration = config;
  contextConfiguration.services = (0, _services.createMockServiceConfiguration)((0, _get.default)(config, 'services', {}));
  return contextConfiguration;
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/config/context-configuration/index.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjb25maWciLCJjb250ZXh0Q29uZmlndXJhdGlvbiIsInNlcnZpY2VzIiwiY3JlYXRlTW9ja1NlcnZpY2VDb25maWd1cmF0aW9uIiwiZ2V0Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbmZpZy9jb250ZXh0LWNvbmZpZ3VyYXRpb24vaW5kZXguanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGdldCBmcm9tICdsb2Rhc2gvZ2V0JztcblxuaW1wb3J0IHsgY3JlYXRlTW9ja1NlcnZpY2VDb25maWd1cmF0aW9uIH0gZnJvbSAnLi4vLi4vc2VydmljZXMnO1xuXG5leHBvcnQgZGVmYXVsdCAoY29uZmlnKSA9PiB7XG5cdGNvbnN0IGNvbnRleHRDb25maWd1cmF0aW9uID0gY29uZmlnO1xuXHRjb250ZXh0Q29uZmlndXJhdGlvbi5zZXJ2aWNlcyA9IGNyZWF0ZU1vY2tTZXJ2aWNlQ29uZmlndXJhdGlvbihcblx0XHRnZXQoY29uZmlnLCAnc2VydmljZXMnLCB7fSksXG5cdCk7XG5cdHJldHVybiBjb250ZXh0Q29uZmlndXJhdGlvbjtcbn07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTtBQUVBO0FBQWdFO0VBQUE7RUFBQTtBQUFBO0FBQUE7RUFBQTtBQUFBO0FBQUEsZUFFakQsa0JBQUNBLE1BQU0sRUFBSztFQUMxQixJQUFNQyxvQkFBb0IsR0FBR0QsTUFBTTtFQUNuQ0Msb0JBQW9CLENBQUNDLFFBQVEsR0FBRyxJQUFBQyx3Q0FBOEIsRUFDN0QsSUFBQUMsWUFBRyxFQUFDSixNQUFNLEVBQUUsVUFBVSxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQzNCO0VBQ0QsT0FBT0Msb0JBQW9CO0FBQzVCLENBQUM7QUFBQTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7SUFBQTtFQUFBO0VBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0FBQUEifQ==